import { createAction, props } from '@ngrx/store';

export const facebookButtonsFormUpdated = createAction(
  '[FacebookButtons] Form Updated',
  props<{
    valid: boolean;
    dataTosave: any;
    dirty: boolean;
    buttonshow: any;
    responseId?: string;
  }>()
);
//initialiser fb button
export const resetButtonTextStates = createAction('[FacebookButton] Init State');


export const deleteFacebookButton = createAction(
  '[Facebook Button] Delete Button',
  props<{ index: number }>()
);
export const resetButtonTextState = createAction(
  '[QuickReplies] Reset State',
  props<{ responseId: string }>()
);

export const cacheButtonState = createAction(
  '[Facebook Buttons] Cache Button State',
  props<{ responseId: string; buttonState: any }>()
);

export const loadButtonStateFromCache = createAction(
  '[Facebook Buttons] Load Button State From Cache',
  props<{ responseId: string }>()
);

export const clearButtonCache = createAction(
  '[Facebook Buttons] Clear Button Cache',
  props<{ responseId: string }>()
);
